import {Alert, Breadcrumb, Button, Spin, Tabs} from "antd";

import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShareServiceWidget} from "../../../../components/calls/service/share-service-widget/share-service-widget";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {ErrorBoundary} from "react-error-boundary";
import {useEffect, useState} from "react";
import {useGetBundleContext} from "../../../../calls/useCases/editBundle/context/get-bundle";
import {EditBundleBasicForm} from "../../../../calls/useCases/editBundle/basic-form";
import {EditBundleCheckoutForm} from "../../../../calls/useCases/editBundle/checkout-form";
import {SalesAndInsights} from "../../../../components/calls/service/sales-and-insights";
import {OfferingAutomations} from "../../../../components/offering-form/automations-step";

type TabKeys = "form" | "checkoutForm" | "automations" | "insights";
const EditBundlePage = () => {
  const pageTitle = "Coaching Bundle";
  const {
    state: {sessionData, isFetchingBundle, isLoadingBundle},
  } = useGetBundleContext();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("form");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "checkoutForm") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "insights") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "automations") {
        setDefaultActiveKey(activeTab);
      }
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "form") {
      setDefaultActiveKey("form");
      navigate(`${window.location.pathname}?activeTab=form`);
    }
    if (key === "checkoutForm") {
      setDefaultActiveKey("checkoutForm");
      navigate(`${window.location.pathname}?activeTab=checkoutForm`);
    }
    if (key === "automations") {
      setDefaultActiveKey("automations");
      navigate(`${window.location.pathname}?activeTab=automations`);
    }
    if (key === "insights") {
      setDefaultActiveKey("insights");
      navigate(`${window.location.pathname}?activeTab=insights`);
    }
  }

  return (
    <DashboardWrapper pageTitle={pageTitle}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/calls">1:1 Sessions</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span
            style={{
              opacity: isFetchingBundle ? 0.2 : 1,
            }}
          >
            {isLoadingBundle ? <Spin /> : sessionData.name}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <Tabs
            defaultActiveKey={defaultActiveKey}
            activeKey={defaultActiveKey}
            onTabClick={(key) => handleTabClick(key)}
          >
            <Tabs.TabPane tab="Bundle details" key="form">
              <Spin spinning={isFetchingBundle}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <EditBundleBasicForm />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Checkout form" key="checkoutForm">
              <Spin spinning={isFetchingBundle}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <EditBundleCheckoutForm />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Automations" key="automations">
              <Spin spinning={isFetchingBundle}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <OfferingAutomations contextOfferingId={sessionData.id} />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Sales and insights" key="insights">
              <SalesAndInsights sessionData={sessionData} />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="widget-area">
          <ShareServiceWidget
            serviceId={sessionData.id}
            serviceData={sessionData}
            isFetchingSession={isFetchingBundle}
          />
        </div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {EditBundlePage};
